import React from 'react';
import { Button, Icon, Tooltip } from '@common/components';

export const RedoActionButton = ({
  tooltipTitle,
  onRedoAction,
}: {
  tooltipTitle: string;
  onRedoAction: () => void;
}) => (
  <Tooltip title={tooltipTitle}>
    <Button
      kind="tertiary"
      size="md"
      shape="circle"
      icon={<Icon icon="undo" />}
      ariaLabel="Redo"
      onClick={onRedoAction}
    />
  </Tooltip>
);
